import React, { useState, useEffect } from 'react'
import ManageBilling from './../../../manageBilling/ManageBilling'
import '../Dashboard.css'
import { useHistory, useParams } from 'react-router-dom'
import UpdateCardModal from './../../../manageBilling/UpdateCardModal'
import NewCardModal from './../../../manageBilling/NewCardModal'
import ChangePropertyModal from './../../../changeProperty/ChangePropertyModal'
import AddNewVehicle from './../../../addNewVehicle/AddNewVehicle'
import { Elements } from '@stripe/react-stripe-js'
import { UserWalletApi } from '../../../apis/UserWallet'
import MyWallet from '../Components/MyWallet'
import MyStatus from '../Components/MyStatus'
import MyProperty from '../Components/MyProperty'
import Skeleton from 'react-loading-skeleton'
import AppShortcutOutlinedIcon from '@mui/icons-material/AppShortcutOutlined'
import { UserVehicleApi } from '../../../apis/UserVehicleApi'
import MySessions from '../Components/MySessions'
import EditBilling from '../Components/EditBilling'
import { GpColumnHeader, Icon, GpButton } from '../../../components/gp'
import { vehicleIconName, vehicleLabel } from '../../../utilities/generalUtils'
import { useAuth } from '../../../auth/Auth'

const ConsumerView = ({
    data,
    isLoading,
    setIsLoading,
    userWalletData,
    reloadWallet,
    myProperty,
    isRecurring,
    showManageBilling,
    manageBilling,
    setShowManageBilling,
    stripePromise,
    navigateToChargingHistory,
}) => {
    // let { secondPathId } = useParams()
    const iosUrl = 'https://apps.apple.com/us/app/gopowerev/id1497166165'
    const androidUrl =
        'https://play.google.com/store/apps/details?id=com.gopowerev.consumer'


    const [openPropertyModal, setOpenPropertyModal] = useState(false)
    const [openVehicleModal, setOpenVehicleModal] = useState(false)
    const [myVehicle, setMyVehicle] = useState({})
    const [myVehicles, setMyVehicles] = useState([])

    // const [cardInfoToEdit, setCardInfoToEdit] = useState({})
    // const [openCardModal, setOpenCardModal] = useState(false)
    // const [openNewCardModal, setOpenNewCardModal] = useState(false)

    const [activeSessions, setActiveSessions] = useState([])
    const [averageChargingPrice, setAverageChargingPrice] = useState(null)
    const [chargingSessions, setChargingSessions] = useState([])
    const [tierUsagePercentage, setTierUsagePercentage] = useState({})
    const [tierUsagePricing, setTierUsagePricing] = useState({})
    const [amountOfTiers, setAmountOfTiers] = useState(0)
    // const [creditCardChanged, setCreditCardChanged] = useState(Date.now())


    const reloadVehicles = () => {
        UserVehicleApi.get()
            .then((data) => {
                setMyVehicle(data.userVehicles[0])
                setMyVehicles(data.userVehicles)
                setIsLoading(false)
            })
            .catch((error) => {
            })
    }


    // const handleEditCardModal = (cardInfo) => {
    //     setOpenCardModal(true)
    //     setCardInfoToEdit(cardInfo)
    // }

    // const handleNewCardModal = () => {
    //     setOpenNewCardModal(true)
    // }

    const downloadApp = () => {
        var userAgent = navigator.userAgent || navigator.vendor || window.opera
        if (/Macintosh|iPhone|iPad|Apple/i.test(userAgent)) {
            window.open(iosUrl, '_blank')
        } else {
            window.open(androidUrl, '_blank')
        }
    }

    useEffect(() => {
        if (data.userVehicles?.length > 0) {
            setMyVehicle(data.userVehicles[0])
            setMyVehicles(data.userVehicles)
        }
    }, [data.userVehicles])


    useEffect(() => {
        // update session data and history UI as data refresh, first load and every 30 seconds
        if (data.userDashboardSessions) {
            setActiveSessions(data.userDashboardSessions?.activeSessions)
            setAverageChargingPrice(data.userDashboardSessions?.averageChargingPrice)
            setChargingSessions(data.userDashboardSessions?.chargingSessions)
            setTierUsagePercentage(data.userDashboardSessions?.tierUsagePercentage)
            setAmountOfTiers(Object.keys(data.userDashboardSessions?.tierUsagePercentage)?.length)
            setTierUsagePricing(data.userDashboardSessions?.tierUsagePricing)
        }
    }, [data.userDashboardSessions])



    const auth = useAuth()
    const attrs = auth.user?.attributes || {}
    const firstName =
        attrs.given_name ||
        (attrs.name ? attrs.name.trim().split(/\s+/)[0] : '') ||
        ''

    const propertyColumn = (
        <div className='gp-property-col'>
            <GpColumnHeader>My Property</GpColumnHeader>
            <div className='gp-property-green'>
                            <MyProperty
                                setOpenPropertyModal={(value) =>
                                    setOpenPropertyModal(value)
                                }
                            />

                            {isLoading ? (
                                <div className='gp-vehicle-card'>
                                    <Skeleton height='20px' borderRadius='6px' />
                                    <Skeleton height='28px' width='150px' borderRadius='999px' />
                                </div>
                            ) : (
                                <>
                                    {myVehicle?.model && (
                                        <div
                                            className='gp-vehicle-card'
                                            style={{ cursor: 'pointer' }}
                                            onClick={() => setOpenVehicleModal(true)}
                                        >
                                            <div style={{ display: 'flex', alignItems: 'center', gap: 10 }}>
                                                <div className='gp-vehicle-icon'>
                                                    <Icon name={vehicleIconName(myVehicle)} size={18} />
                                                </div>
                                                <div>
                                                    <div style={{ font: 'var(--gp-body-med)' }}>
                                                        {myVehicle.name}
                                                    </div>
                                                    {myVehicle?.parkingSpot != null && (
                                                        <div style={{ font: 'var(--gp-caption)', color: 'var(--gp-ink-mute)' }}>
                                                            {myVehicle.parkingSpot.locationName} · {myVehicle.parkingSpot.name}
                                                        </div>
                                                    )}
                                                </div>
                                            </div>
                                            <div className='gp-vehicle-plate'>
                                                {vehicleLabel(myVehicle)}
                                            </div>
                                        </div>
                                    )}
                                    {!myVehicle?.model && (
                                        <div className='gp-vehicle-card'>
                                            <div style={{ font: '400 14px/1.45 var(--gp-font)', color: 'var(--gp-ink-mute)' }}>
                                                You have no vehicle set up
                                            </div>
                                        </div>
                                    )}
                                </>
                            )}

                            <div className='gp-property-actions'>
                                <button
                                    type='button'
                                    className='gp-ghost-dark'
                                    onClick={() => setOpenPropertyModal(true)}
                                >
                                    Change Property
                                </button>
                                <button
                                    type='button'
                                    className='gp-ghost-dark'
                                    onClick={() => setOpenVehicleModal(true)}
                                >
                                    Manage Vehicles
                                </button>
                                <button
                                    type='button'
                                    className='gp-ghost-dark download-app-button'
                                    onClick={() => downloadApp()}
                                >
                                    <AppShortcutOutlinedIcon fontSize='small' />
                                    Download our App
                                </button>
                            </div>
            </div>
        </div>
    )

    const billingSidebar = (
        <div className='gp-property-col'>
            <GpColumnHeader>My Property</GpColumnHeader>
            <MyProperty
                bordered
                setOpenPropertyModal={(value) => setOpenPropertyModal(value)}
            />
            <div style={{ height: 16 }} />
            {isLoading ? (
                <div
                    className='gp-vehicle-card'
                    style={{ border: '1px solid var(--gp-hairline)', boxShadow: 'var(--gp-shadow-sm)' }}
                >
                    <Skeleton height='20px' borderRadius='6px' />
                    <Skeleton height='28px' width='150px' borderRadius='999px' />
                </div>
            ) : myVehicle?.model ? (
                <div
                    className='gp-vehicle-card'
                    style={{ border: '1px solid var(--gp-hairline)', boxShadow: 'var(--gp-shadow-sm)', cursor: 'pointer' }}
                    onClick={() => setOpenVehicleModal(true)}
                >
                    <div style={{ display: 'flex', alignItems: 'center', gap: 10 }}>
                        <div className='gp-vehicle-icon'>
                            <Icon name={vehicleIconName(myVehicle)} size={18} />
                        </div>
                        <div>
                            <div style={{ font: 'var(--gp-body-med)' }}>
                                {myVehicle.name}
                            </div>
                            {myVehicle?.parkingSpot != null && (
                                <div style={{ font: 'var(--gp-caption)', color: 'var(--gp-ink-mute)' }}>
                                    {myVehicle.parkingSpot.locationName} · {myVehicle.parkingSpot.name}
                                </div>
                            )}
                        </div>
                    </div>
                    <div className='gp-vehicle-plate'>
                        {vehicleLabel(myVehicle)}
                    </div>
                </div>
            ) : (
                <div
                    className='gp-vehicle-card'
                    style={{ border: '1px solid var(--gp-hairline)', boxShadow: 'var(--gp-shadow-sm)' }}
                >
                    <div style={{ font: '400 14px/1.45 var(--gp-font)', color: 'var(--gp-ink-mute)' }}>
                        You have no vehicle set up
                    </div>
                </div>
            )}
            <div
                style={{
                    margin: '20px 0',
                    height: 1,
                    background:
                        'repeating-linear-gradient(to right, var(--gp-hairline) 0, var(--gp-hairline) 4px, transparent 4px, transparent 8px)',
                }}
            />
            <div style={{ display: 'flex', flexDirection: 'column', gap: 10 }}>
                <GpButton
                    variant='ghost'
                    style={{ width: '100%' }}
                    onClick={() => setOpenPropertyModal(true)}
                >
                    Change Property
                </GpButton>
                <GpButton
                    variant='ghost'
                    style={{ width: '100%' }}
                    onClick={() => setOpenVehicleModal(true)}
                >
                    Manage Vehicles
                </GpButton>
            </div>
        </div>
    )

    const dashboardGrid = (
        <div className='gp-dash-grid'>
            {propertyColumn}
            <MyStatus
                isRecurring={isRecurring}
                powerType={myProperty.powerType}
            />
            <MyWallet
                loading={isLoading}
                userWalletData={userWalletData}
                manageBilling={manageBilling}
                isRecurring={isRecurring}
                topUpAmount={data.userSettings.topUpAmount}
            />
            <MySessions
                isRecurring={isRecurring}
                myProperty={myProperty}
                tierUsagePercentage={tierUsagePercentage}
                tierUsagePricing={tierUsagePricing}
                averageChargingPrice={averageChargingPrice}
                chargingSessions={chargingSessions}
                navigateToChargingHistory={navigateToChargingHistory}
            />
        </div>
    )

    const billingGrid = (
        <div className='gp-dash-grid gp-dash-grid--billing'>
            {billingSidebar}
            <div className='gp-billing-slot'>
                <EditBilling
                    data={data}
                    reloadWallet={reloadWallet}
                    setShowManageBilling={setShowManageBilling}
                    stripePromise={stripePromise}
                    userWalletData={userWalletData}
                    myProperty={myProperty}
                    isRecurring={isRecurring}
                />
            </div>
        </div>
    )

    return (
        <div className='dashboard-page-container'>
            <h1 className='gp-page-title'>
                Welcome back{firstName ? `, ${firstName}` : ''}
            </h1>
            <p className='gp-page-sub'>
                Here's a quick look at your charging, wallet and property.
            </p>
            {showManageBilling ? billingGrid : dashboardGrid}
            {/* MODALS */}
            <ChangePropertyModal
                open={openPropertyModal}
                handleClose={() => setOpenPropertyModal(false)}
                myProperty={myProperty}
            />
            <AddNewVehicle
                open={openVehicleModal}
                vehicles={myVehicles}
                handleClose={() => setOpenVehicleModal(false)}
                reloadVehicles={reloadVehicles}
            />
        </div>
    )
}

export default ConsumerView
